import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import areArraysEqual from 'utils/areArraysEqual';
import { sortByRank } from '.';

/**
 * This function recursively checks each level of the playlist
 * content tree to check if it differs from the initial state.
 */

export function checkWasPlaylistStructureChanged(newContentTree, oldContentTree) {
  // Check 1: Is the number of items on this level different?
  if (newContentTree.length !== oldContentTree.length) {
    return true;
  }

  // Check 2: Is the order of items on this level different?
  var newSiblingItemIds = newContentTree.sort(sortByRank).map(function (item) {
    return item.id;
  });
  var oldSiblingItemIds = oldContentTree.sort(sortByRank).map(function (item) {
    return item.id;
  });
  if (!areArraysEqual(newSiblingItemIds, oldSiblingItemIds)) {
    return true;
  }

  // Check 3: Perform the same checks for all section children
  return newContentTree.some(function (item) {
    if (item.type !== 'section') {
      return false;
    }
    var oldItem = oldContentTree.find(function (oldItem) {
      return oldItem.id === item.id;
    });
    if (!oldItem) {
      // If we can't find this section at this level in the old content,
      // we can bail out early. But given the previous checks this shouldn't happen.
      return true;
    }
    return checkWasPlaylistStructureChanged(item.children, oldItem.children);
  });
}